import * as React from 'react';
import { WidgetLayout } from './parts/WidgetLayout';
import { NotAvailableScreen } from './parts/NotAvailableScreen';
import { RoomTypeFilter } from './parts/RoomTypeFilter';
import { LayoutsCards } from './parts/LayoutsCards';
import { OffersLinks } from './parts/OffersLinks';
import { useLayouts } from '../../hooks';
import { useTracking } from '../../hooks/useTracking';
import { Controls } from './parts/Controls';
import { Pagination } from './parts/Pagination';
import { LayoutModal } from '../LayoutModal';
import { useLayoutModal } from '../../hooks/useLayoutModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var Layouts = function Layouts(_ref) {
  var newbuildingId = _ref.newbuildingId,
    houseId = _ref.houseId,
    roomsCountList = _ref.roomsCountList,
    isHouseLayoutsAvailable = _ref.isHouseLayoutsAvailable,
    pageTypeJK = _ref.pageTypeJK,
    callButton = _ref.callButton,
    onHouseFilterReset = _ref.onHouseFilterReset,
    isLayoutModalDisabled = _ref.isLayoutModalDisabled,
    favoriteButton = _ref.favoriteButton,
    isQueryParamsEnabled = _ref.isQueryParamsEnabled;
  var _useLayouts = useLayouts({
      newbuildingId: newbuildingId,
      houseId: houseId,
      isHouseLayoutsAvailable: isHouseLayoutsAvailable,
      isQueryParamsEnabled: isQueryParamsEnabled
    }),
    layouts = _useLayouts.layouts,
    onLayoutsReset = _useLayouts.onLayoutsReset,
    roomType = _useLayouts.roomType,
    onRoomTypeChange = _useLayouts.onRoomTypeChange,
    isLoading = _useLayouts.isLoading,
    isError = _useLayouts.isError,
    offersLinks = _useLayouts.offersLinks,
    pagination = _useLayouts.pagination;
  var _useTracking = useTracking({
      newbuildingId: newbuildingId,
      pageTypeJK: pageTypeJK,
      houseId: houseId
    }),
    trackListingLinkClick = _useTracking.trackListingLinkClick,
    trackLayoutModalOpen = _useTracking.trackLayoutModalOpen,
    trackTourClick = _useTracking.trackTourClick,
    trackFlatCardClick = _useTracking.trackFlatCardClick,
    trackHeaderLinkClick = _useTracking.trackHeaderLinkClick;
  var _useLayoutModal = useLayoutModal({
      newbuildingId: newbuildingId,
      houseId: houseId,
      layouts: layouts,
      isLayoutModalDisabled: isLayoutModalDisabled
    }),
    isOpened = _useLayoutModal.isOpened,
    onClose = _useLayoutModal.onClose,
    onReset = _useLayoutModal.onReset,
    onLayoutCardClick = _useLayoutModal.onLayoutCardClick,
    isLayoutLoading = _useLayoutModal.loading,
    layoutImageUrl = _useLayoutModal.layoutImageUrl,
    layoutOffers = _useLayoutModal.layoutOffers;
  if (!isHouseLayoutsAvailable) {
    return /*#__PURE__*/_jsx(WidgetLayout, {
      children: /*#__PURE__*/_jsx(NotAvailableScreen, {
        onHouseFilterReset: onHouseFilterReset
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(WidgetLayout, {
      children: [!isError && /*#__PURE__*/_jsx(RoomTypeFilter, {
        roomsCountList: roomsCountList,
        onChange: onRoomTypeChange,
        value: roomType
      }), /*#__PURE__*/_jsx(LayoutsCards, {
        layouts: layouts,
        isLoading: isLoading,
        isError: isError,
        onLayoutCardClick: onLayoutCardClick,
        onReset: onLayoutsReset,
        trackLayoutModalOpen: trackLayoutModalOpen,
        trackListingLinkClick: trackListingLinkClick,
        isLayoutModalDisabled: isLayoutModalDisabled
      }), /*#__PURE__*/_jsxs(Controls, {
        children: [!isError && /*#__PURE__*/_jsx(Pagination, {
          page: pagination.page,
          onChange: pagination.onPageChange,
          lastPage: pagination.lastPage
        }), !isLoading && /*#__PURE__*/_jsx(OffersLinks, {
          linksInfo: offersLinks,
          houseId: houseId,
          roomType: roomType,
          trackClick: trackListingLinkClick
        })]
      })]
    }), /*#__PURE__*/_jsx(LayoutModal, {
      onClose: onClose,
      onReset: onReset,
      open: isOpened,
      isLoading: isLayoutLoading,
      layoutImageUrl: layoutImageUrl,
      callButton: callButton,
      layoutOffers: layoutOffers,
      trackTourClick: trackTourClick,
      trackHeaderLinkClick: trackHeaderLinkClick,
      trackFlatCardClick: trackFlatCardClick,
      favoriteButton: favoriteButton
    })]
  });
};